import { isFunction } from "../utils";
import builtinRules from "./rules";

export declare type ValidatorRuleResult = { [key: string]: string } | undefined;

export interface ValidatorArgs {
    msg?: string;
}

export interface ValidatorRule {
}


export declare type ValidatorRuleFunc = (name: string, values: { [key: string]: any }, args: ValidatorArgs) => ValidatorRuleResult;

export declare type ValidatorRules = { [key: string]: ValidatorRule | ValidatorRuleFunc };

export interface ValidatorFieldDef {
    validate?: ValidatorRules;
}

export interface ValidatorField {
    value?: any;
}

export declare type ValidatorFields = { [key: string]: ValidatorField };

interface ValidatorObj {
    name: string;
    fn: ValidatorRuleFunc;
    args: any;
}

export const defaultArgs = {
    locale: "en-US"
};

const getBuiltinRules = (k: string): ValidatorRuleFunc => {
    const fn = builtinRules[k];
    const valFunc = fn as ValidatorRuleFunc;
    if (valFunc !== undefined)
        return valFunc;

    throw `"Unknown rule '${k}'`;
};

const buildFieldRules = (field: ValidatorFieldDef, name: string): Array<ValidatorObj> => {
    let rules: Array<ValidatorObj> = [];

    if (!field.validate || Object.keys(field.validate).length === 0)
        return [];

    for (let n in field.validate) {
        const v = field.validate[n];
        if (isFunction(v))
            rules.push({ name: name, fn: v as ValidatorRuleFunc, args: {} });
        else
            rules.push({ name: name, fn: getBuiltinRules(n), args: v });

    }
    return rules;
};


export const buildValidator = (fields: { [key: string]: ValidatorFieldDef }, getDefaultArgs = () => defaultArgs) => {

    let validatioinRules: { [key: string]: Array<ValidatorObj> } = {};

    for (const n in fields) {
        validatioinRules[n] = buildFieldRules(fields[n], n)
    }

    return (valFields: ValidatorFields) => {
        //console.log("XXX-validate: ", fields, valFields, validatioinRules);
        //console.log("RULES: ", validatioinRules);
        const defArgs = getDefaultArgs();
        let errors = {};
        const values: { [key: string]: any } = {};
        for (const fn in valFields) {
            values[fn] = valFields[fn].value;
        }
        for (const fn in valFields) {
            //console.log("VAL-field: ", fn);
            for (const r of validatioinRules[fn]) {
                //console.log("N: ", r);
                //const r = validatioinRules[field][i];
                //console.log("R: ", r);

                valFields.map
                const err = r.fn(fn, values, { ...defArgs, ...r.args });
                if (err && Object.keys(err).length !== 0) {
                    errors = Object.assign(errors, err);
                    break;
                }
            }
        }
        //  console.log("VAL-errors: ", errors);
        return errors;
    };
};
